import { Alert, AlertProps } from '@material-ui/lab';

import { Icon } from '@/components/shared/components/Icon';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface CustomCartAlertProps extends AlertProps {
  icon?: string;
  style?: React.CSSProperties;
}

export const CustomCartAlert = ({ icon = 'info', severity = 'info', style, children }: CustomCartAlertProps) => {
  const { customBorderRadius } = useCustomTheme();

  return (
    <Alert
      severity={severity}
      icon={<Icon size={22}>{icon}</Icon>}
      style={{ borderRadius: customBorderRadius.paper, ...style }}
    >
      {children}
    </Alert>
  );
};
